<script setup lang="ts">
  import { ref, onServerPrefetch } from 'vue';
  const isMounted = ref(false);

  onServerPrefetch(() => {
    isMounted.value = true;
  });
</script>

<template>
  <div v-if="isMounted">
    <slot />
  </div>
</template>
